// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__10r6C","signatureBlock":"Footer_signatureBlock__3WtZY","signature":"Footer_signature__yC5Qo"};